/**
 * CP-480: rango de fechas por defecto de Bind → Movimientos (Transferencias y
 * Otros movimientos). Sin fechas la pantalla traía todo el histórico (≈294k
 * transferencias en la cuenta 45, oct-2026) hasta el tope de 100.000 y en un
 * orden no cronológico. Arranca con las últimas 24 h: ayer y hoy, porque
 * `fecha_valor` no tiene hora. Para otro período se cambian las fechas.
 *
 * `fecha_valor` es una fecha sin hora (YYYY-MM-DD) y el backend filtra con
 * `between(from, to)` inclusivo, así que `to` = hoy incluye el día completo.
 *
 * Sin imports de runtime para que corra con `node --test`.
 */

export const DIAS_POR_DEFECTO = 1;   // antes 7 (última semana)

/** Tope de seguridad de la carga paginada (páginas × filas por página). */
export const TOPE_PAGINAS = 500;
export const FILAS_POR_PAGINA = 200;
export const TOPE_FILAS = TOPE_PAGINAS * FILAS_POR_PAGINA;

const AR_TZ = "America/Argentina/Buenos_Aires";

/** YYYY-MM-DD de `d` en hora Argentina. */
export function isoAr(d: Date): string {
  // en-CA formatea como YYYY-MM-DD.
  return new Intl.DateTimeFormat("en-CA", { timeZone: AR_TZ, year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
}

/** Rango por defecto: [hoy − DIAS_POR_DEFECTO, hoy], en hora Argentina. */
export function rangoPorDefecto(now: Date = new Date()): { from: string; to: string } {
  const to = isoAr(now);
  const [y, m, d] = to.split("-").map(Number);
  const from = new Date(Date.UTC(y, m - 1, d - DIAS_POR_DEFECTO)).toISOString().slice(0, 10);
  return { from, to };
}

export const esRangoPorDefecto = (from: string, to: string, now: Date = new Date()) => {
  const r = rangoPorDefecto(now);
  return from === r.from && to === r.to;
};
